module.exports = __webpack_public_path__ + "media/images/cardboard-img-07-6d4238dc32958af066679f84fbd153dc.jpg";